<template lang='pug'>
.main-container

  .view-content
    div
      el-card
        div(slot='header')
          i.mat-icon person
          | Customers
          el-button(type="primary", @click="startCreatingCustomer()", style='float: right')
            i.mat-icon add_circle
            | New customer
        el-table(:data='customers', v-loading='customers == null')
          el-table-column(type='expand')
            template(slot-scope='props')
              customer(:backend-data='props.row', @deleted='getCustomers')
          el-table-column(label='Account name', prop='account_name')
          el-table-column(label='Location')
            template(slot-scope='scope', v-if='scope.row.city')
              | {{scope.row.city}}, {{scope.row.state}} {{scope.row.zip_code}}

  el-dialog(:visible.sync='creatingCustomer', title='Create customer')

    el-form(ref="form", label-width="150px", v-if='newCustomer != null')

      el-form-item(label='Account name')
        el-input(placeholder="", v-model='newCustomer.account_name')
      el-form-item(label='Email')
        el-input(placeholder="", v-model='newCustomer.email')
      el-form-item(label='Password')
        el-input(placeholder="", v-model='newCustomer.password')
    .submit-dialog
      el-button(type='primary', @click='createCustomer()')
        | Create customer


  el-col()
    el-pagination( 
      v-if="pagination.pages > 1"
      @current-change="onPaginationChange"
      :page-size="pagination.per_page", 
      :pager-count="pagination.pages", 
      layout="prev, pager, next", 
      :total="pagination.total") 
  router-view
</template>

<script>

  import Customer from './blocks/Customer.vue'
  import auth from "../auth.js"

  function data(){
    return {
      customers: null,
      creatingCustomer: false,
      newCustomer: null,
      pagination: {
        per_page: null,
        current: null,
        pages: null,
        total: null,
      }
    }
  }

  function onPaginationChange(current_page){
    this.getCustomers(current_page);
  }

  function createCustomer(){
    return this.$simplecater.post('/customers', this.newCustomer).then((r)=> {
      const customer = r.data.data
      this.getCustomers()
      this.creatingCustomer = false
      console.log("NEW CUSTOMER RESULT", customer)
    }).catch(this.$handleErrorFor("create customer").bind(this))
  }

  function getCustomers(current_page){
    let params = (current_page ?{params:{ page:current_page}}:{});
    return this.$simplecater.get('/customers',params).then((r)=> {
      this.customers = r.data.data,
      this.pagination = r.data.pagination;
    })
  }

  function created(){
    this.getCustomers()
  }

  const watch = {
    '$route' (to, from) {
      this.getCustomers()
    }
  }

  function startCreatingCustomer(){
    this.newCustomer = {}
    this.creatingCustomer = true
  }

  const components = { Customer }

  const methods = {
    getCustomers, onPaginationChange, createCustomer, startCreatingCustomer
  }

  export default {methods, components, data, created }
</script>



// WEBPACK FOOTER //
// src/staff/Customers.vue